import React from 'react';
import { Tag } from 'antd';
import { SynonymWarning } from '../../../lib/api/searchDictionary';

type TermTagsProps = {
  terms: string[];
  /** 경고가 걸린 토큰은 주황으로 칠한다 */
  warnings?: SynonymWarning[];
};

export const TermTags = (props: TermTagsProps): React.JSX.Element => {
  const { terms, warnings = [] } = props;
  const warned = new Set(warnings.map((warning) => warning.term?.toLowerCase()).filter(Boolean));
  return (
    <span className="term-tags">
      {terms.map((term) => (
        <Tag key={term} color={warned.has(term.toLowerCase()) ? 'orange' : undefined}>
          {term}
        </Tag>
      ))}
    </span>
  );
};
